
const deep_copy = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const obj_eq = (obj_a, obj_b) => {
  return JSON.stringify(obj_a) === JSON.stringify(obj_b);
}

/**
 * A comparison function for sorting strings.
 * @param a_str {String}
 * @param b_str {String}
 * @return {int}
 */
const string_cmp = (a_str, b_str) => {
  if (a_str > b_str) {
    return 1;
  }
  if (a_str < b_str) {
    return -1;
  }
  return 0;
};

const string_cmp_inv = (a_str, b_str) => {
  if (a_str < b_str) {
    return 1;
  }
  if (a_str > b_str) {
    return -1;
  }
  return 0;
};

/**
 * obj[path_0][path_1][...] = value
 * @param obj Object
 * @param path [String]
 * @param value Object
 */
const deep_assign = (obj, path, value) => {
  let lastKeyIndex = path.length-1;
  for (let i = 0; i < lastKeyIndex; i++) {
    let key = path[i];
    if (!(key in obj)){
      obj[key] = {}
    }
    obj = obj[key];
  }
  obj[path[lastKeyIndex]] = value;
};

/**
 * Retrieves the array pointed to by obj[path][path] in an
 * object of the form { arr: value }. This way it can be
 * passed around to be processed. (Arrays can't be passed by
 * reference so we pass an enclosing object instead.)
 * If the array doesn't exist, we create an empty array.
 *
 * @param obj Object
 * @param path [String]
 */
const deep_array_return = (obj, path) => {
  let lastKeyIndex = path.length-1;
  for (let i = 0; i < lastKeyIndex; i++) {
    let key = path[i];
    if (!(key in obj)){
      obj[key] = {}
    }
    obj = obj[key];
  }
  if (!(path[lastKeyIndex] in obj)) {
    obj[path[lastKeyIndex]] = [];
  }
  const result = { arr: obj[path[lastKeyIndex]] }
  return result;
}

/**
 * @param obj {Object}
 * @param path {[String]}
 * @param value {Object} Can't be a constant, have to be an object.
 */
const deep_update = (obj, path, value) => {
  for (let i = 0; i < path.length; i++) {
    let key = path[i];
    if (!(key in obj)){
      obj[key] = {}
    }
    obj = obj[key];
  }
  Object.assign(obj, value);
};

const path_exists = (obj, path) => {
  let result = true;
  for(let i=0; i < path.length; i++) {
    const key = path[i];

    if (!(key in obj)) {
      result = false;
      break;
    }
    obj = obj[key];
  }
  return result;
}

export { deep_copy, obj_eq, string_cmp, deep_assign, deep_update,
  string_cmp_inv, path_exists, deep_array_return };
